var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 80,
    viewBox: "0 0 100 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.28 51.265C85.8 47.93 83.225 45.33 79.91 44.555C67.025 41.535 63.795 34.115 63.25 25.885C60.965 25.46 56.9 25 50 25C43.1 25 39.035 25.46 36.75 25.885C36.205 34.115 32.975 41.535 20.09 44.555C16.775 45.335 14.2 47.93 13.72 51.265L11.235 68.475C10.36 74.535 14.81 80 21 80H79C85.185 80 89.64 74.535 88.765 68.475L86.28 51.265ZM50 67.46C43.025 67.46 37.37 61.86 37.37 54.96C37.37 48.06 43.025 42.46 50 42.46C56.975 42.46 62.63 48.06 62.63 54.96C62.63 61.86 56.97 67.46 50 67.46ZM99.75 20C99.63 12.5 80.54 0.005 50 0C19.455 0.005 0.365021 12.5 0.250021 20C0.135021 27.5 0.355021 37.26 12.925 35.635C27.63 33.73 26.725 28.595 26.725 21.255C26.725 16.135 38.685 14.9 50 14.9C61.315 14.9 73.27 16.135 73.275 21.255C73.275 28.595 72.37 33.73 87.075 35.635C99.64 37.26 99.865 27.5 99.75 20Z",
    fill: "#3DAFE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2edae14c18f0d953ae243b52f6b0ee05.svg";
export { ForwardRef as ReactComponent };